const Rata = {
    // id_Rata:"A4DKSS",
    isRata: Math.random() < 0.5
}

export default Rata;